import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { LegalArticle } from '@/components/generals/legal-article'
import { contact } from '@/constants/site'

const Impressum: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title='Impressum' description='Impressum von Unity Dome Berlin, Paul-Lincke-Ufer 40, 10999 Berlin.' />

            <LegalArticle eyebrow='Rechtliches' title='Impressum'>
                <h2>Anbieter</h2>
                <p>
                    {contact.organisation}
                    <br />
                    {contact.street}
                    <br />
                    {contact.postcode} {contact.city}
                </p>

                <h2>Kontakt</h2>
                <p>
                    E-Mail: <a href={`mailto:${contact.email}`}>{contact.email}</a>
                </p>

                <h2>Redaktionell verantwortlich</h2>
                <p>F. Bräuer</p>
            </LegalArticle>
        </Layout>
    )
}

export default Impressum
